/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_PUBLISH_DATA, PUBLISH_DATA_RECEIVED } = constants.PublishConstants;

export default {
    REQUEST_PUBLISH_DATA,
    PUBLISH_DATA_RECEIVED,

  requestPublishData: payload => ({
    type: REQUEST_PUBLISH_DATA,
    payload
  }),
  publishDataReceived: () => ({
    type: PUBLISH_DATA_RECEIVED
  }),
};
